/**
 * @fileoverview Utility functions for handling user logout functionality.
 * This module provides a logout function that cleans up user session data and handles redirects.
 *
 * @example
 * // Basic logout
 * logout();
 * // Will redirect to /login
 *
 * @example
 * // Logout due to timeout
 * logout('timeout');
 * // Will redirect to /login?timeout=true&return=currentURL
 *
 * @example
 * // Logout due to security reason
 * logout('security');
 * // Will redirect to /login?security=true&return=currentURL
 */


/**
 * Logs the user out by removing the token and user from local storage and redirecting to the login page
 * @param timeout Indicates whether the user was logged out due to inactivity
 */
export function logout(reason?: string) {
    const currentURL = new URL(window.location.href)

    // Sanitize the URL to avoid multiple timeout, security and return params
    if (currentURL.searchParams) {
        currentURL.searchParams.delete('timeout')
        currentURL.searchParams.delete('return')
        currentURL.searchParams.delete('security')
    }

    localStorage.removeItem('token')
    localStorage.removeItem('expiringAt')
    localStorage.removeItem('user')
    localStorage.removeItem('intercom')

    if (reason === 'timeout') {
        window.location.href = '/login?timeout=true&return=' + window.location.href
        return
    }

    if (reason === 'security') {
        window.location.href = '/login?security=true&return=' + window.location.href
        return
    }

    window.location.href = '/login'
}
